import React, { useEffect, useRef, useState } from 'react';
import { getCall } from '../hooks/Network';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toggleMobileSearch } from '../slices/uiSlice';
import { MenuItem, Select } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useOrderSearch } from '../hooks/Helper';
import { setSearchType } from '../slices/searchSlice';
import { flagEnabled } from '../util/flags';
import useFlagsHook from '../hooks/useFlags.hook';

const SearchAssociate = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { searchType } = useSelector((state) => state.search);
  const [searchCustomer, setSearchCustomer] = useState('');
  const [associateCustomers, setAssociateCustomers] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [highlightIndex, setHighlightIndex] = useState(-1);
  const { isFlagEnabled } = useFlagsHook();
  const inputRef = useRef(null);

  const apiToken = localStorage.getItem('apiToken');
  const bearerToken = JSON.parse(apiToken)?.jwtToken;
  const navigate = useNavigate();
  const { searchOrders } = useOrderSearch();
  const handleSubmit = (associateId) => {
    if (searchType === 'customer') {
      fnIsSearch();
      navigate(`/customers/${associateId}/summary`);
      return;
    }
    const res = searchOrders({
      type: 'ordernumber',
      search: searchCustomer.trim(),
    });
    if (res.data && res.data.data.length > 0) {
      const order = res.data.data[0];
      navigate(`/customers/${order.associateId}/Orders/${order.orderNumber}`);
    }
  };

  const fnIsSearch = () => {
    dispatch(toggleMobileSearch());
    if (isSearch) {
      setSearchCustomer('');
      setAssociateCustomers([]);
      setIsSearch(false);
    } else {
      setIsSearch(true);
    }
  };

  useEffect(() => {
    if (isSearch && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isSearch]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (searchCustomer.length >= 1 && searchType === 'customer') {
        fnSearch();
      } else {
        setAssociateCustomers([]);
      }
    }, 300);

    return () => clearTimeout(timeout);
  }, [searchCustomer]);

  const fnSearch = async () => {
    if (searchCustomer.length >= 1 && searchType === 'customer') {
      let getData = {
        url: 'associateSearch',
        urlParams: { req: searchCustomer },
        headers: { Authorization: 'Bearer ' + bearerToken },
      };
      let cResponse = await getCall(getData);

      if (cResponse.data) {
        setAssociateCustomers(cResponse.data);
        // if (cResponse.data.length === 1) {
        //     handleSubmit(cResponse.data[0].associateId);
        // }
      }
    }
    if (searchType === 'order') {
      const res = await searchOrders({
        type: 'ordernumber',
        search: searchCustomer.trim(),
      });
      if (res.data && res.data.data.length > 0) {
        const order = res.data.data[0];
        navigate(`/customers/${order.associateId}/Orders/${order.orderNumber}`);
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightIndex((prev) => Math.min(prev + 1, associateCustomers.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (highlightIndex >= 0 && associateCustomers[highlightIndex]) {
        handleSubmit(associateCustomers[highlightIndex].associateId);
      }
    }
  };

  const handleInputChange = (e) => {
    setSearchCustomer(e.target.value);
    setHighlightIndex(-1);
  };

  return (
    <>
      <div className='mb-search-sec'>
        <span
          className='mb-search-icn'
          onClick={() => {
            fnIsSearch();
          }}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='icon'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            strokeWidth='2'
            stroke='currentColor'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <circle cx='10' cy='10' r='7' />
            <line x1='21' y1='21' x2='15' y2='15' />
          </svg>
        </span>
        {isSearch && (
          <div className='mb-search-div  w-100'>
            <div className='inp-ss  align-items-center w-100'>
              {isFlagEnabled('SEARCH_ORDER_DROPDOWN') && (
                <Select
                  size='small'
                  value={searchType}
                  onChange={(e) => {
                    dispatch(setSearchType(e.target.value));
                  }}
                  sx={{ minWidth: 110, height: '43px', borderRadius: '0 0 0 0' }}
                >
                  <MenuItem value='customer'>{t('associate')}</MenuItem>
                  <MenuItem value='order'>{t('order')}</MenuItem>
                </Select>
              )}
              <input
                className={`mb-cs-search `}
                ref={inputRef}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
                placeholder={'search...'}
                disabled={isDisabled}
                autoComplete='off'
                value={searchCustomer}
              />
              <button onClick={fnSearch}>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='icon'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  strokeWidth='2'
                  stroke='currentColor'
                  fill='none'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                >
                  <path stroke='none' d='M0 0h24v24H0z' fill='none' />{' '}
                  <circle cx='10' cy='10' r='7' />{' '}
                  <line x1='21' y1='21' x2='15' y2='15' />
                </svg>
              </button>
            </div>
            {associateCustomers?.length > 0 && (
              <div className='cs-list-items'>
                {associateCustomers.map((item, index) => {
                  return (
                    <div
                      key={item.associateId}
                      className={`cs-list-item ${highlightIndex === index ? 'highlighted' : ''}`}
                      onClick={() => handleSubmit(item.associateId)}
                      onMouseEnter={() => setHighlightIndex(index)}
                      style={{
                        backgroundColor: highlightIndex === index ? '#f0f0f0' : 'white',
                        cursor: 'pointer',
                        padding: '8px',
                      }}
                    >
                      {item.firstName} {item.lastName} ({item.backOfficeId}) -{' '}
                      {item.email}
                    </div>
                  );
                })}
              </div>
            )}
            {associateCustomers.length === 0 &&
              searchCustomer.length > 0 &&
              searchType === 'customer' && (
                <div className='autocomplete-no-match'>{t('noMatchesFound')}</div>
              )}
          </div>
        )}
      </div>
    </>
  );
};

export default SearchAssociate;
